import translate from 'rcm-i18n';
import React, {Component} from 'react';
import {FixedAspectRatioDiv} from '@rcm/fixed-aspect-ratio-div-react';
import PlayerIFrame from './PlayerIFrame';
import './PopupPlayer.css';

interface PopupPlayerProps {
    videoId: string;
    aspectRatio: string;
    onClose: () => void;
    downloadUrl: string;
}

export default class PopupPlayer extends Component<PopupPlayerProps> {

    public render() {
        return <div className="vimeo-popup-player-popup-player-container" onClick={this.props.onClose}>
            <div className="vimeo-popup-player-popup-player-container-content">
                <div className="vimeo-popup-player-popup-player-buttons">
                    <a className="btn btn-primary" href={this.props.downloadUrl} onClick={this.stopPropagation}>
                        {translate('Download Video')}
                    </a>
                    <button className="btn btn-primary vimeo-popup-player-popup-close-button"
                            onClick={this.props.onClose}>
                        {translate('Back')}
                    </button>
                </div>
                <FixedAspectRatioDiv aspectRatio={this.props.aspectRatio}>
                    <PlayerIFrame videoId={this.props.videoId} mode="autoplay"/>
                </FixedAspectRatioDiv>
            </div>
        </div>;
    }
    /**
     * People can close the popup by clicking the overlay margin. This
     * prevents clicks on buttons from bubbling up and triggering the overlay margin
     * click.
     *
     * @param event
     */
    private stopPropagation(event) {
        event.stopPropagation();
    }
}
